import { axiosInstance } from "./axiosInstance";

export const reportsService = {
  // Survey Reports
  getSurveyOverview: async () => {
    const response = await axiosInstance.get('/reports/surveys');
    return response.data;
  },

  getSurveyReport: async (id) => {
    const response = await axiosInstance.get(`/reports/surveys/${id}`);
    return response.data;
  },

  getSurveySegmentation: async (id) => {
    const response = await axiosInstance.get(`/reports/surveys/${id}/segmentation`);
    return response.data;
  },

  getSurveyQuestionDistribution: async (id) => {
    const response = await axiosInstance.get(`/reports/surveys/${id}/questions/distribution`);
    return response.data;
  },

  getSurveyInsights: async (id) => {
    const response = await axiosInstance.get(`/reports/surveys/${id}/insights`);
    return response.data;
  },

  getSurveyDropoff: async (id) => {
    const response = await axiosInstance.get(`/reports/surveys/${id}/dropoff`);
    return response.data;
  },

  // Campaign Reports
  getCampaignReport: async (id) => {
    const response = await axiosInstance.get(`/reports/campaigns/${id}`);
    return response.data;
  },
};